"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./GuidesHeroSec.scss");

var _InfoLozenge = _interopRequireDefault(require("../InfoLozenge"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var GuidesHeroSec = function GuidesHeroSec(props) {
  var _props$data = props.data,
      headerText = _props$data.headerText,
      coverImg = _props$data.coverImg,
      coverIcon = _props$data.coverIcon,
      activeIcon = _props$data.activeIcon;
  return _react.default.createElement("section", {
    className: "guidesHero"
  }, _react.default.createElement("img", {
    className: "guidesHeroImgFit",
    src: coverImg.url,
    alt: "tyres"
  }), !activeIcon ? "" : _react.default.createElement("img", {
    className: "guidesHeroIcon",
    src: coverIcon,
    alt: "guide Icon"
  }), _react.default.createElement("h1", {
    className: "guidesTextH1"
  }, headerText), _react.default.createElement(_InfoLozenge.default, null));
};

GuidesHeroSec.defaultProps = {
  headerText: "",
  coverImg: {
    url: ""
  },
  coverIcon: "",
  iconActive: ""
};
var _default = GuidesHeroSec;
exports.default = _default;